import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_VEHICLES_DOCUMENTS_DATA } from "./actionTypes";
import {
  fetchVehiclesDocumentsSuccess,
  fetchVehiclesDocumentsFailure,
} from "./actions";

function* fetchVehiclesDocumentsDataSaga(action) {
  try {
    const { page = 1, limit = 10, driverId, vehicleCategoryId } = action.payload || {};
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (driverId) params.set('driverId', String(driverId));
    if (vehicleCategoryId) params.set('vehicle_category_id', String(vehicleCategoryId));
    const url = process.env.REACT_APP_WEB_APP_URL + `/api/web/vehicles-documents?${params.toString()}`;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const payload = response.data;
    if (payload.total == null && Array.isArray(payload.data)) {
      payload.total = payload.data.length;
    }
    yield put(fetchVehiclesDocumentsSuccess(payload));
  } catch (error) {
    yield put(fetchVehiclesDocumentsFailure(error.message));
  }
}

export default function* vehiclesDocumentsSaga() {
  yield takeEvery(FETCH_VEHICLES_DOCUMENTS_DATA, fetchVehiclesDocumentsDataSaga);
}
